export const translations = {
  no: {
    nav: {
      services: "Tjenester",
      why: "Hvorfor oss",
      coverage: "Område",
      reviews: "Vurderinger",
      faq: "FAQ",
      contact: "Kontakt",
      quote: "Få gratis tilbud",
    },
    hero: {
      eyebrow: "FLYTTEBYRÅ  •  VARETRANSPORT  •  STAVANGER",
      title_1: "RASKT HJEM.",
      title_2: "TRYGG FLYTTING.",
      subtitle:
        "Profesjonell flyttebyrå og varetransport i Rogaland. Vi flytter hjem, kontorer og gods – raskt, forsikret og uten stress.",
      cta_primary: "Få gratis tilbud",
      cta_secondary: "Ring 923 23 408",
      stat_1_k: "1200+",
      stat_1_v: "Flyttinger",
      stat_2_k: "4.9/5",
      stat_2_v: "Gjennomsnittlig vurdering",
      stat_3_k: "24/7",
      stat_3_v: "Tilgjengelig support",
    },
    services: {
      eyebrow: "TJENESTER",
      title: "Vi løser hele flyttingen",
      subtitle:
        "Fra pakking til montering – Raskt Hjem AS tilbyr en komplett flytteopplevelse under ett tak.",
      items: [
        { title: "Privatflytting", desc: "Trygg flytting av leilighet, hus eller rom. Forsikret gods og erfarne flyttefolk." },
        { title: "Bedriftsflytting", desc: "Kontorflytting i helger og netter – null nedetid for driften din." },
        { title: "Varetransport", desc: "Budbil og varebilstransport i Rogaland. Fast pris, rask levering." },
        { title: "Pakking & materiell", desc: "Vi leverer esker, bobleplast og teip – eller pakker hele hjemmet for deg." },
        { title: "Bortkjøring av avfall", desc: "Rydder ut gamle møbler, oppussingsavfall og storsekker. Miljøvennlig levering." },
        { title: "Montering av møbler", desc: "IKEA, Jysk eller spesialmøbler – vi monterer og demonterer alt." },
      ],
    },
    why: {
      eyebrow: "HVORFOR RASKT HJEM AS",
      title: "Bygget for hastighet og tillit",
      items: [
        { k: "Raskt svar", v: "Tilbud innen 60 minutter på hverdager." },
        { k: "Forsikret", v: "All flytting er fullforsikret – uten tillegg." },
        { k: "Fastpris", v: "Ingen skjulte gebyrer. Du får prisen før vi starter." },
        { k: "Lokalt team", v: "Sjåfører og flyttefolk bosatt i Rogaland." },
      ],
    },
    coverage: {
      eyebrow: "OMRÅDE",
      title: "Vi dekker hele Rogaland",
      subtitle:
        "Med base i Stavanger betjener vi privat- og bedriftskunder i hele regionen — og tilbyr langtransport etter avtale.",
      cities: ["Stavanger", "Sandnes", "Sola", "Randaberg", "Hafrsfjord", "Hundvåg", "Madla", "Forus", "Klepp", "Time"],
    },
    form: {
      eyebrow: "FORESPØRSEL",
      title: "Få gratis tilbud",
      subtitle: "Fyll ut skjemaet — vi svarer innen 60 minutter.",
      name: "Navn",
      phone: "Telefon",
      email: "E-post",
      service: "Tjeneste",
      service_placeholder: "Velg tjeneste",
      date: "Ønsket dato",
      from: "Fra adresse",
      to: "Til adresse",
      message: "Melding (valgfritt)",
      message_placeholder: "Antall rom, spesielle gjenstander, heis/trapper, osv.",
      submit: "Send forespørsel",
      sending: "Sender...",
      success: "Takk! Vi tar kontakt så snart som mulig.",
      error: "Noe gikk galt. Prøv igjen eller ring oss direkte.",
    },
    testimonials: {
      eyebrow: "VURDERINGER",
      title: "Kunder som flyttet raskt hjem",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Ofte stilte spørsmål",
      items: [
        { q: "Hvor raskt kan dere flytte oss?", a: "På hverdager kan vi ofte starte innen 24–48 timer. Ring oss for akuttflytting." },
        { q: "Er flyttingen forsikret?", a: "Ja, all flytting er inkludert i standard transportforsikring. Vi tilbyr også utvidet dekning ved behov." },
        { q: "Tilbyr dere fastpris?", a: "Ja. Vi kommer på befaring (fysisk eller digital) og gir en bindende fastpris før oppstart." },
        { q: "Hvilke områder dekker dere?", a: "Hele Rogaland – Stavanger, Sandnes, Sola, Randaberg, Klepp og omegn. Langtransport etter avtale." },
        { q: "Kan dere ta bortkjøring av avfall samtidig?", a: "Ja, vi håndterer både flytting og bortkjøring av avfall/gamle møbler i samme oppdrag." },
      ],
    },
    contact: {
      eyebrow: "KONTAKT",
      title: "Snakk med Mostafa",
      phone_label: "Telefon",
      email_label: "E-post",
      hours_label: "Åpningstider",
      hours_value: "Man–Lør: 07:00–20:00",
      area_label: "Hovedkontor",
      area_value: "Stavanger, Rogaland",
    },
    footer: {
      tagline: "Flyttebyrå og varetransport i Rogaland",
      rights: "Alle rettigheter forbeholdt.",
    },
    services_list: [
      "Privatflytting",
      "Bedriftsflytting",
      "Varetransport",
      "Pakking",
      "Bortkjøring av avfall",
      "Montering av møbler",
    ],
  },
  en: {
    nav: {
      services: "Services",
      why: "Why us",
      coverage: "Coverage",
      reviews: "Reviews",
      faq: "FAQ",
      contact: "Contact",
      quote: "Get free quote",
    },
    hero: {
      eyebrow: "MOVING  •  VAN TRANSPORT  •  STAVANGER",
      title_1: "QUICKLY HOME.",
      title_2: "SAFE MOVING.",
      subtitle:
        "Professional moving and van transport across Rogaland. We move homes, offices and cargo – fast, insured and stress-free.",
      cta_primary: "Get free quote",
      cta_secondary: "Call +47 923 23 408",
      stat_1_k: "1200+",
      stat_1_v: "Moves completed",
      stat_2_k: "4.9/5",
      stat_2_v: "Average rating",
      stat_3_k: "24/7",
      stat_3_v: "Support available",
    },
    services: {
      eyebrow: "SERVICES",
      title: "We handle the entire move",
      subtitle:
        "From packing to assembly — Raskt Hjem AS offers a complete moving experience under one roof.",
      items: [
        { title: "Private moving", desc: "Safe moves of apartments, houses or single rooms. Insured goods and experienced movers." },
        { title: "Office moving", desc: "Weekend and night office moves — zero downtime for your business." },
        { title: "Van transport", desc: "Courier and cargo van transport in Rogaland. Fixed price, fast delivery." },
        { title: "Packing & supplies", desc: "We deliver boxes, bubble wrap and tape — or pack your entire home for you." },
        { title: "Waste removal", desc: "We clear old furniture, renovation debris and bulk bags. Environmentally friendly disposal." },
        { title: "Furniture assembly", desc: "IKEA, Jysk or custom furniture — we assemble and disassemble everything." },
      ],
    },
    why: {
      eyebrow: "WHY RASKT HJEM AS",
      title: "Built for speed and trust",
      items: [
        { k: "Fast reply", v: "Quote within 60 minutes on weekdays." },
        { k: "Insured", v: "All moves are fully insured — no surcharge." },
        { k: "Fixed price", v: "No hidden fees. You get the price before we start." },
        { k: "Local team", v: "Drivers and movers living in Rogaland." },
      ],
    },
    coverage: {
      eyebrow: "COVERAGE",
      title: "We cover all of Rogaland",
      subtitle:
        "Based in Stavanger, we serve private and business customers across the region — long-distance transport by arrangement.",
      cities: ["Stavanger", "Sandnes", "Sola", "Randaberg", "Hafrsfjord", "Hundvåg", "Madla", "Forus", "Klepp", "Time"],
    },
    form: {
      eyebrow: "REQUEST",
      title: "Get a free quote",
      subtitle: "Fill the form — we reply within 60 minutes.",
      name: "Name",
      phone: "Phone",
      email: "Email",
      service: "Service",
      service_placeholder: "Select service",
      date: "Preferred date",
      from: "From address",
      to: "To address",
      message: "Message (optional)",
      message_placeholder: "Number of rooms, special items, elevator/stairs, etc.",
      submit: "Send request",
      sending: "Sending...",
      success: "Thank you! We'll be in touch shortly.",
      error: "Something went wrong. Please try again or call us directly.",
    },
    testimonials: {
      eyebrow: "REVIEWS",
      title: "Customers who moved quickly home",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "How quickly can you move us?", a: "On weekdays we can often start within 24–48 hours. Call us for urgent moves." },
        { q: "Is the move insured?", a: "Yes, all moves include standard transport insurance. Extended coverage is available." },
        { q: "Do you offer fixed pricing?", a: "Yes. We do a walkthrough (in person or digital) and give a binding fixed price before starting." },
        { q: "Which areas do you cover?", a: "All of Rogaland — Stavanger, Sandnes, Sola, Randaberg, Klepp and surroundings. Long-distance by arrangement." },
        { q: "Can you remove waste at the same time?", a: "Yes, we handle both moving and removal of old furniture/waste in one job." },
      ],
    },
    contact: {
      eyebrow: "CONTACT",
      title: "Talk to Mostafa",
      phone_label: "Phone",
      email_label: "Email",
      hours_label: "Opening hours",
      hours_value: "Mon–Sat: 07:00–20:00",
      area_label: "Headquarters",
      area_value: "Stavanger, Rogaland",
    },
    footer: {
      tagline: "Moving and van transport in Rogaland",
      rights: "All rights reserved.",
    },
    services_list: [
      "Private moving",
      "Office moving",
      "Van transport",
      "Packing",
      "Waste removal",
      "Furniture assembly",
    ],
  },
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_f3dfd55a-ace6-4f47-b5c6-c2664f1a0a92/artifacts/vdrakkag_IMG_1602.png";
export const HERO_VAN_URL =
  "https://images.unsplash.com/photo-1688619102725-f2fd886313e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxtZXJjZWRlcyUyMHNwcmludGVyJTIwdmFuJTIwY2FyZ298ZW58MHx8fHwxNzc3OTc3ODk5fDA&ixlib=rb-4.1.0&q=85";
export const MOVING_URL =
  "https://images.unsplash.com/photo-1758523671139-33fd9913e456?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxjYXJyeWluZyUyMG1vdmluZyUyMGJveGVzfGVufDB8fHx8MTc3Nzk3NzkwMHww&ixlib=rb-4.1.0&q=85";
export const STAVANGER_URL =
  "https://images.unsplash.com/photo-1462278622651-830cfd7e1f08?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxzdGF2YW5nZXIlMjBub3J3YXklMjBjaXR5fGVufDB8fHx8MTc3Nzk3NzkwMHww&ixlib=rb-4.1.0&q=85";

export const CONTACT = {
  phone_display: "923 23 408",
  phone_tel: "+4792323408",
  email: "mostafahaji577@gmail.com",
  owner: "Mostafa",
  company: "Raskt Hjem AS",
};
